import React from 'react'
import { withSiteData } from 'react-static'

import Hero from '../components/Hero'
import Planning from '../components/Planning'
import Development from '../components/Development'
import Refurbishment from '../components/Refurbishment'
import AssetManagement from '../components/Asset-Management'
import StrategicLandPromotion from '../components/Strategic-Land-Promotion'
import Contact from '../components/Contact'

const heroOptions = {
  title: [
    "Glenbeigh Developments Ltd",
    <br className="hidden-sm" />,
    "is a Development and",
    <br className="hidden-sm" />,
    "Asset Management company"],
  copy: [
    "We specialise in the investment and development of",
    <br className="hidden-sm" />,
    "office, industrial and residential property outside the",
    <br className="hidden-sm" />,
    "M25 – from Kent across to Dorset."],
  image: "hero-home.jpg"
}

export default withSiteData(() => (
  <React.Fragment>
    <Hero {...heroOptions} />
    <Planning />
    <Development />
    <Refurbishment />
    <AssetManagement />
    <StrategicLandPromotion />
    <Contact />
  </React.Fragment>
))



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/containers/Home.js